import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text-2xl" }, "Contact Information", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")
  const _component_v_form = _resolveComponent("v-form")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, { class: "m-4 p-2 bg-gray-200" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        id: "app",
        onSubmit: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_input_field, {
            modelValue: _ctx.nameValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.nameValue = $event)),
            name: "name",
            label: "Name",
            required: true
          }, null, 8, ["modelValue"]),
          _createVNode(_component_input_field, {
            modelValue: _ctx.emailValue,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.emailValue = $event)),
            name: "email",
            label: "Email Address",
            required: true
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}